import { toast } from "@/components/ui";
import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
interface CompleteVideoVisitMeetingParams {
  completed: boolean;
  encounterId: string;
}

export const useCompleteVideoVisitMeeting = ({
  shouldShowToast = true,
}: { shouldShowToast?: boolean } = {}) => {
  return useApiMutation<void, CompleteVideoVisitMeetingParams>({
    mutationOptions: {
      mutationKey: QueryKeys.VIDEO_VISIT.COMPLETE,
      mutationFn: ({ encounterId, completed }) => {
        return axiosInstance.post("new-api/video-visit/mark-visit-ended", {
          encounterId,
          completed,
        });
      },
      onSuccess: (_, { completed }) => {
        if (shouldShowToast) {
          if (completed) {
            toast.success("Video visit meeting completed");
          } else {
            toast.warning("Closing incomplete video call");
          }
        }
      },
      onError: () => {
        toast.error("Failed to complete video visit meeting");
      },
    },
  });
};
